<template lang="pug">
.FProductHero
  header.FProductHero__header
    h2.FProductHero__header__overline {{ t(`product__${type}__overline`) }}
    h1.FProductHero__header__headline(v-html="t(`product__${type}__headline`)")

  .FProductHero__image
    FImage(
      :src="`/images/product/${type}/hero.jpg`"
      :placeholder="`/images/product/${type}/hero.placeholder.jpg`"
      :alt="t(`product__${type}__image__alt`)"
      corners="rounded"
      width="100%"
      fit="cover"
      position="relative"
    ) 

  p.FProductHero__text {{ t(`product__${type}__text`) }}
</template>

<style lang="stylus">
.FProductHero
  position relative
  width 100%
  height 100%
  // Takes into account 3 params: margin-top of header, header height and margin-bottom of header
  padding rem(128 + 80 + 32) 0 rem(96) 0

  +media-down('xs')
    padding rem(64 + 80 + 32) 0 rem(48) 0

  &__header
    width 100%
    position relative
    text-align center

    &__overline
      use-font('overline')
      text-transform uppercase
      margin-bottom rem(16)
      padding 0 rem(24)

      +media-down('xs')
        text-align left

    &__headline
      use-font('heading-2')
      padding 0 rem(24)

      +media-down('xs')
        use-font('heading-3')
        text-align left

  &__text
    use-font('body-1')
    max-width rem(960)
    text-align center
    margin 0 auto
    padding 0 rem(24)

    +media-down('xs')
      max-width none
      text-align left

  &__image
    width 100%
    position relative
    display flex
    justify-content center
    align-items center
    margin rem(96) rem(0) rem(48) rem(0)
    padding 0 rem(48)

    .FImage__image,
    .FImage__placeholder
      min-height rem(100%)
      min-width 100%

      +media-down('xs')
        aspect-ratio 1 / 1

    +media-down('xs')
      margin rem(48) rem(0) rem(24) rem(0)
      padding 0 rem(24)
</style>

<script setup lang="ts">
export interface FProductHeroProps {
  /**
   * String to identify product type
   */
  type: ProductType;
}

defineProps<FProductHeroProps>();

const { t } = useI18n();
</script>
